import React, { ReactNode } from 'react';

import { classNames } from '@/helpers/classNames';
import { Dialog, Slide, useMediaQuery } from '@material-ui/core';

import constants from '../../../theme/exportedVariables.module.scss';
import styles from './AsaphDialog.module.scss';

export interface AsaphDialogProps {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
	maxHeight?: number;
	className?: string;
	paperClassName?: string;
}

export const AsaphDialog = ({
	children,
	onClose,
	open,
	maxHeight,
	className,
	paperClassName,
}: AsaphDialogProps) => {
	const fullScreen = !useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	return (
		<Dialog
			fullScreen={fullScreen}
			open={open}
			onClose={onClose}
			scroll="paper"
			TransitionComponent={Transition as any}
			className={className}
			classes={{
				paper: classNames([
					styles['asaph-dialog__paper'],
					paperClassName,
				]),
				paperFullScreen: styles['asaph-dialog__paper--full-screen'],
			}}
			PaperProps={{
				style: {
					maxHeight: fullScreen ? 'auto' : maxHeight,
				},
			}}
		>
			{children}
		</Dialog>
	);
};

const Transition = React.forwardRef(function Transition(props: any, ref) {
	return <Slide direction="up" ref={ref} timeout={500} {...props} />;
});

export default AsaphDialog;
